var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoEnvirontmentParents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 76.5 104.9",
    style: {
      enableBackground: "new 0 0 76.5 104.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 21.8,
    cy: 47.1,
    r: 9.7
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 54.1,
    cy: 47.3,
    r: 9.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icono_15",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M18.1,66.2 c-3.5-4.4-5.6-10-5.6-16C12.5,36,24,24.5,38.2,24.5S63.9,36,63.9,50.2c0,6.1-2.1,11.6-5.6,16"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#069AB3"
    },
    cx: 38.2,
    cy: 24.4,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#79BF43"
    },
    cx: 64,
    cy: 47.4,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E1E433"
    },
    cx: 12.5,
    cy: 47.4,
    r: 6.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#069AB3"
    },
    d: "M38.3,66.6l-4.8-6.4h-9.1v26.9h15.3h8.1c2.4,0,4.4-2,4.4-4.4v-6.6V60.2h-9L38.3,66.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    cx: 38.3,
    cy: 47.4,
    rx: 10.1,
    ry: 10.1
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M38.3,66.6l-4.8-6.4h-9.1v26.9h15.3h8.1 c2.4,0,4.4-2,4.4-4.4v-6.6V60.2h-9L38.3,66.6z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    cx: 38.2,
    cy: 24.4,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    cx: 64,
    cy: 47.4,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    cx: 12.5,
    cy: 47.4,
    r: 6.5
  })), /*#__PURE__*/React.createElement("rect", {
    y: 14.2,
    style: {
      display: "inline",
      fill: "none"
    },
    width: 76.5,
    height: 76.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icono_14",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#EC8C23"
    },
    points: "29.3,62.2 29.8,56.9 26.2,60.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#EC8C23"
    },
    points: "21.2,62.2 20.7,56.9 24.3,60.6  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9AA9B"
    },
    d: "M51.7,54.3c0,0,2.1-3.5,4.4-1.1c0,0-0.5,3.7,1.2,5.6s-0.8,3.3-3.3,2.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9AA9B"
    },
    d: "M43.6,54.3c0,0-2.1-3.5-4.4-1.1c0,0,0.5,3.7-1.2,5.6s0.8,3.3,3.3,2.3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#A39382"
    },
    cx: 47.7,
    cy: 59.5,
    rx: 6.1,
    ry: 6.1
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A39382"
    },
    d: "M56.2,87.1V75.5c0-4.4-3.6-7.9-7.9-7.9H47c-4.4,0-7.9,3.6-7.9,7.9v11.6H56.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M56.2,87.1V75.5c0-4.4-3.6-7.9-7.9-7.9H47 c-4.4,0-7.9,3.6-7.9,7.9v11.6H56.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    cx: 47.7,
    cy: 59.5,
    rx: 6.1,
    ry: 6.1
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M51.7,54.3c0,0,2.1-3.5,4.4-1.1c0,0-0.5,3.7,1.2,5.6s-0.8,3.3-3.3,2.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M43.6,54.3c0,0-2.1-3.5-4.4-1.1c0,0,0.5,3.7-1.2,5.6s0.8,3.3,3.3,2.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 47.2,60.8 48.2,60.8 47.7,61.5  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 43.6,
    y1: 87.1,
    x2: 43.6,
    y2: 78.3
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 51.1,
    y1: 87.1,
    x2: 51.1,
    y2: 78.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EC8C23"
    },
    cx: 25.2,
    cy: 65.2,
    rx: 4.6,
    ry: 4.6
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EC8C23"
    },
    d: "M31.7,87.1v-8.8c0-3.3-2.7-6-6-6h-1c-3.3,0-6,2.7-6,6v8.8H31.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M31.7,87.1v-8.8c0-3.3-2.7-6-6-6h-1 c-3.3,0-6,2.7-6,6v8.8H31.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    cx: 25.2,
    cy: 65.2,
    rx: 4.6,
    ry: 4.6
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: "24.8,66.1  25.6,66.1 25.2,66.7  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 22.2,
    y1: 87.1,
    x2: 22.2,
    y2: 80.4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 27.8,
    y1: 87.1,
    x2: 27.8,
    y2: 80.4
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: "29.3,62.2  29.8,56.9 26.2,60.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: "21.2,62.2  20.7,56.9 24.3,60.6  "
  })), /*#__PURE__*/React.createElement("rect", {
    y: 14.2,
    style: {
      display: "inline",
      fill: "none"
    },
    width: 76.5,
    height: 76.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icono_13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F27FB2"
    },
    d: "M40.8,87.1h14.9h7.9c2.4,0,4.3-1.9,4.3-4.3v-6.4V60.9h-8.8h-4.7h-4.6h-8.9v4.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M40.8,87.1h14.9h7.9c2.4,0,4.3-1.9,4.3-4.3v-6.4 V60.9h-8.8h-4.7h-4.6h-8.9v4.2L40.8,87.1L40.8,87.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C7C9C7",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 62.4,
    cy: 36.6,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7C9C7"
    },
    d: "M30.2,42.1c-3,3.2-8.2,1.4-8.2,1.4c-4.1,2-8.2-1.4-8.2-1.4s2.9-4.9,8.2-4.6 C22,37.5,27.5,37.5,30.2,42.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1B432"
    },
    d: "M22,67.5l4.6-6.1h8.7v25.7H20.7H13c-2.3,0-4.2-1.9-4.2-4.2v-6.3V61.4h8.6L22,67.5z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    cx: 21.9,
    cy: 47.1,
    rx: 9.7,
    ry: 9.7
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M35.2,87.1H20.6h-7.7c-2.3,0-4.2-1.9-4.2-4.2 v-6.3V61.4h8.6l4.6,6.1l4.6-6.1h8.7v4V87.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7C9C7"
    },
    d: "M62.2,41.3c-2.1,4.6-9.2,1.9-9.2,1.9c-5.3,2.4-6.5-1.9-6.5-1.9s2.7-3.8,7.8-3.9 C54.3,37.4,63.1,39.2,62.2,41.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    cx: 54.3,
    cy: 47.3,
    rx: 9.9,
    ry: 9.9
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M46.5,41.3c0,0,1.3,4.3,6.5,1.9c0,0,6.1,3.1,9.2-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M13.7,42.1c0,0,4.1,3.4,8.2,1.4c0,0,5.2,1.8,8.2-1.4"
  })), /*#__PURE__*/React.createElement("rect", {
    y: 14.2,
    style: {
      fill: "none"
    },
    width: 76.5,
    height: 76.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEnvirontmentParents);
export default __webpack_public_path__ + "static/media/ico-Environtment-Parents.5c245617920b6c5164d3b62847effd48.svg";
export { ForwardRef as ReactComponent };